import { GlobalService } from 'src/app/_services/global.service';
import { AppBaseDataService } from 'src/app/_services/app-base-data.service';
import { Component, OnInit } from '@angular/core';
import { ProductsService } from 'src/app/_services/products.service';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-product-pricing',
  templateUrl: './product-pricing.component.html',
  styleUrls: ['./product-pricing.component.scss']
})
export class ProductPricingComponent implements OnInit {
  editform: FormGroup
  _globals = GlobalService
  
  selectedDefaultPrice:any=''

  constructor(
    public _productService: ProductsService,
    public _abd: AppBaseDataService,
    private _fb: FormBuilder,
  ) {}

  ngOnInit(): void {
    this.selectedDefaultPrice = this._productService.selectedDefaultPrice
    this.initForm()
    if (!this._productService.activeItem) {
      const original = this._productService.productInfo.taxRate[0];

        if (original) {
          // Clone the object
          const s = { ...original };

          // 1) Remove the trailing number (e.g. " 1")
          s.name = s.name.replace(/\s\d+$/, '');

          // 2) Append the percentage
          const percentage = this._abd.systemConfigs.taxConfig.tax1;
          s.name = `${s.name} (${percentage}%)`;

          // Update taxRates
          this._productService.taxRates = [s];
          this._productService.selectedTaxRate = s;
        }
    }
  }

  initForm() {
    this.editform = this._fb.group({
      priceA: [{value:this._productService.pts.priceA,disabled: this._productService.isViewOnly}, Validators.required],
      priceB: [{value:this._productService.pts.priceB,disabled: this._productService.isViewOnly}, this._globals.validateNonZeroNumber],
      priceC: [{value:this._productService.pts.priceC,disabled: this._productService.isViewOnly}, this._globals.validateNonZeroNumber],
      costPrice: [{value:this._productService.pts.costPrice,disabled: this._productService.isViewOnly}, this._globals.validatePositive],
      discountPrice: [{value:this._productService.pts.discountPrice,disabled: this._productService.isViewOnly}, this._globals.validateNonZeroNumber],
      caseQty: [{value:this._productService.pts.caseQty,disabled: this._productService.isViewOnly}, this._globals.validateNonZeroNumber],
    })

  }

  sellQtyChanged(e) {
    //console.log(this._productService.selectedSellQuantity.value)
  }

  defaultPriceChange(e) {
    this._productService.selectedDefaultPrice = e.value
  }

  isFormValid() {
    return this.editform.valid
  }

  onZeroValueFocus(controlName: string, event: FocusEvent): void {
    const input = event?.target as HTMLInputElement | null;
    if (!input) return;
    const rawValue = (input.value || '').trim();
    if (!this.isZeroDisplayValue(rawValue)) return;
    const control = this.editform?.get(controlName);
    if (control) {
      control.setValue(null);
    }
    if (this._productService?.pts && controlName in this._productService.pts) {
      this._productService.pts[controlName] = null;
    }
    setTimeout(() => {
      try {
        input.setSelectionRange(0, 0);
      } catch {}
    }, 0);
  }

  private isZeroDisplayValue(value: string): boolean {
    const normalized = value.replace(/[^0-9.-]/g, '');
    if (!normalized) return false;
    const numericValue = Number(normalized);
    return !isNaN(numericValue) && numericValue === 0;
  }

}
